import { BoxDataType } from '.';
import { useState, useEffect, useRef } from 'react';
import TextInput from '../../../../lib/TextField';
import { useHistory } from 'react-router';
import { Button, FormControl, MenuItem, Select } from '@material-ui/core';
import DatePickerInput from '../../../../lib/DatePicker';
import _ from 'lodash';
import { getDate } from '../../../../utils/constants';
import { ValidationErrorRes } from '../ExploreMFs/types';
import { getAge } from '../ExploreMFs/mf-helpers';
import en from '../../../../lang/en-us';
const { common } = en;

export type PurchaseDetailsBoxProps = {
    heading: string;
    boxDetails: BoxDataType[];
    editRedirect?: any;
    preFillData?: any;
    index?: number;
    canDelete?: boolean;
    extraDetails?: any;
    handleDelete?: any;
    onChange?: any;
    preFillDataKey?: string;
    submitCallBack?: any;
    errorSection?: ValidationErrorRes;
    kfinFlag?: boolean;
};

export const PurchaseDetailsBox = ({
    boxDetails,
    heading,
    editRedirect,
    preFillData,
    index,
    canDelete,
    extraDetails,
    handleDelete,
    onChange,
    submitCallBack,
    preFillDataKey,
    errorSection,
    kfinFlag,
}: PurchaseDetailsBoxProps) => {
    const [editing, setEditing] = useState<boolean>(false);
    // const [boxData, setBoxdata] = useState<BoxDataType[]>(boxDetails);
    const [errPresent, setErrPresent] = useState<boolean>(false);
    const history = useHistory();

    const handleChange = (e: any) => {
        onChange((prevState: BoxDataType[]) => {
            return prevState.map((item) => {
                let targetValue = !!e.target ? e.target.name : e.constructor.name;
                if (item.name === targetValue) {
                    if (!!item.validate && typeof item.validate === 'function') {
                        if (!item.validate.call({}, e.target.value)) return item;
                    }
                    if (!!item.maxLength && Number(item.maxLength) < `${e.target.value}`?.length) {
                        return item;
                    }
                    item.value = item.upperCase
                        ? e.target.value.toUpperCase()
                        : item.datePicker
                        ? e
                        : e.target.value;
                }
                return item;
            });
        });
    };

    const deleteCallBack = (index: number, e: any) => {
        if (!!handleDelete) handleDelete(index);
    };

    useEffect(() => {
        setErrPresent(() =>
            boxDetails.some((item) => {
                if (item.errors) {
                    return item.errors(item.value);
                }
                return false;
            }),
        );
    }, [boxDetails]);

    const resetData = useRef<any>([]);

    const resetValues = () => {
        onChange(() => resetData.current);
        // cancel editing
        setEditing(false);
    };

    // Edit -> link Redirect => state -> Screen Load
    const handleEdit = () => {
        //handle edit when redirecting to a different page
        if (!!editRedirect) {
            if (!!index) {
                history.push(`/portal/commercial/${editRedirect}`, {
                    [preFillDataKey || 'data']: preFillData,
                    kfinFlag,
                    index: index - 1,
                });
            } else {
                history.push(`/portal/commercial/${editRedirect}`, {
                    [preFillDataKey || 'data']: preFillData,
                    kfinFlag,
                });
            }
        }
        //inline editing
        //storing [name,values] pairs in ref for reset
        resetData.current = boxDetails.map((ele) => ({ ...ele }));
        //setting editing to true
        setEditing(true);
    };

    const handleSubmit = () => {
        if (!errPresent) {
            //API CALL
            submitCallBack();
            setEditing(false);
        }
    };

    return (
        <div
            className="box personalDetails-box"
            style={{ border: errorSection?.error ? '2px solid rgba(255, 0, 0 , 0.6)' : '' }}
        >
            <h3>
                {heading}{' '}
                {errorSection?.error && (
                    <span
                        style={{
                            fontSize: 10,
                            color: 'red',
                            display: 'block',
                        }}
                    >
                        * {errorSection.message}
                    </span>
                )}
            </h3>
            <div className="box-details">
                {boxDetails.map(
                    (
                        {
                            label,
                            value,
                            isEditable,
                            name,
                            errors = () => false,
                            dropDown,
                            dropDownValues = [],
                            datePicker = false,
                            getHelperText = undefined,
                            helperObjectForValues = null,
                            displayValue = null,
                            isNumber = false,
                        },
                        index,
                    ) => (
                        <div className="box-details-info">
                            <p>{label} </p>
                            {editing && isEditable ? (
                                dropDown ? (
                                    <FormControl variant="filled">
                                        <Select onChange={handleChange} value={value} name={name}>
                                            {dropDownValues.map((item: any) => (
                                                <MenuItem value={item}>
                                                    {helperObjectForValues
                                                        ? helperObjectForValues[item]
                                                        : item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                ) : datePicker ? (
                                    <>
                                        <DatePickerInput
                                            onChange={handleChange}
                                            name={name}
                                            value={value ? getDate(value) : null}
                                            error={errors(value)}
                                            minDate={
                                                new Date(
                                                    new Date().getFullYear() - 100,
                                                    new Date().getMonth(),
                                                    new Date().getDate(),
                                                )
                                            }
                                            helperText={
                                                errors(value)
                                                    ? common.errors.dob.minorAgeValidation
                                                    : ''
                                            }
                                        />
                                    </>
                                ) : (
                                    <TextInput
                                        value={value}
                                        onChange={handleChange}
                                        name={name}
                                        error={errors(value)}
                                        helperText={
                                            errors(value)
                                                ? !!getHelperText
                                                    ? getHelperText(value)
                                                    : `Please enter a valid ${name}`
                                                : ''
                                        }
                                        inputProps={isNumber ? { inputMode: 'numeric' } : undefined}
                                    />
                                )
                            ) : (
                                <h6>
                                    {datePicker
                                        ? value
                                            ? new Date(value).toLocaleDateString('IND')
                                            : ''
                                        : dropDown
                                        ? helperObjectForValues[value]
                                        : value}
                                </h6>
                            )}
                        </div>
                    ),
                )}
            </div>
            {!!extraDetails && extraDetails}
            <img
                className="edit-icon save-icon"
                hidden={!editing || errPresent}
                onClick={handleSubmit}
                src="/images/green-tick.svg"
                alt=""
            />
            <img
                className={canDelete ? 'edit-icon save-icon' : 'edit-icon'}
                src={editing ? '/images/close-red.svg' : '/images/edit-fill-purple.svg'}
                alt={editing ? 'close-icon' : 'edit-icon'}
                onClick={editing ? resetValues : handleEdit}
            />
            {canDelete && index && (
                <img
                    className="edit-icon"
                    src="/images/delete-folio.svg"
                    alt="delete icon"
                    onClick={() => deleteCallBack(index - 1, null)}
                />
            )}
            {editing && (
                <div className="mobile_mode">
                    <div className="buttons" style={{ display: 'flex' }}>
                        <Button
                            onClick={handleSubmit}
                            className="customBtn"
                            style={{ marginRight: 15, border: '1px solid #836fe0' }}
                        >
                            {common.save}
                        </Button>
                        <Button
                            onClick={resetValues}
                            className="customBtn cancelBtn"
                            style={{
                                background: '#fff',
                                color: '#836fe0',
                                border: '1px solid #636c88',
                            }}
                        >
                            {common.cancel}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};
